import { useTranslation } from 'react-i18next';
import { VaultIcon } from '../../icons';
import { NotYetListItem } from './NotYetListItem';

export function NoVaultsListItem() {
  const { t } = useTranslation();
  return <NotYetListItem icon={<VaultIcon />} title={t('No vaults yet')} />;
}
